import React, { useState } from 'react'
import FullPageAlert from '../styles/fullPageAlert'
import Button from './common/Button'
import { Close, TopImage } from '../styles/image'
import { Wrapper, WrapperBottomButton } from '../styles/elements'
import CloseIcon from '../assets/icons/exit.svg'

export default ({ children, buttonText, onClose, headerImage, hasCloseIcon = true }) => {
  const [isShown, setShown] = useState(true)
  const onClick = () => {
    onClose && onClose()
    setShown(false)
  }

  return (
    isShown && (
      <FullPageAlert>
        <TopImage src={headerImage} />
        {hasCloseIcon && <Close src={CloseIcon} alt="" onClick={onClick} isBright />}
        <Wrapper>
          {children}
          <WrapperBottomButton>
            <Button text={buttonText} onClick={onClick} />
          </WrapperBottomButton>
        </Wrapper>
      </FullPageAlert>
    ))
}
